export enum ChartDisplayMode {
    WIZARD = "wizard",
    CHARTING = "charting",
    ENTSIGNALS = "signals"
}

export function DisplayModeParams(): object {
    let tabsParams: { id: string; label: string }[] = [
        { id: ChartDisplayMode.WIZARD, label: "Wizard" },
        { id: ChartDisplayMode.CHARTING, label: "Charting" },
        { id: ChartDisplayMode.ENTSIGNALS, label: "Entry signals" }
    ];
    return tabsParams;
}

export function gettradeDeskTabsList(): string[][] {
    let res: string[][] = [];
    for (const n in ChartDisplayMode) {
        if (ChartDisplayMode.hasOwnProperty(n)) {
            res.push([n, (<any>ChartDisplayMode)[n]]);
        }
    }
    return res;
}
